module.exports = __webpack_public_path__ + "img/产品服务3.5d88ef5b.png";